import { HoardOrder } from "../../../state/types"
import { HoardPDFPage } from './hoardPDFPage'
import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { Item } from "../../../../operations"

type Props = {
    id: string
    hoard: HoardOrder
    previewMode?: boolean
}

export const HoardPDF = (props: Props) => {
    const { id, hoard, previewMode } = props

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <HoardPDFPage
            pageIndex={pageIndex}
            hoard={dataType as HoardOrder}
            items={items}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={hoard}
            items={hoard.items}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
